import * as React from 'react'
import { connect } from 'react-redux'
import { Table } from 'semantic-ui-react'

import HTMLText from '../../system-wide/html-text'
import withToggle from '../../../enhancers/toggleable'
import MatrixCell from '../matrix/cell'
import { SelectField } from '../../formfields'

const mstp = (state, props) => {
  return { rowComment: state.data[props.currentPageName][props.jsonref.split('.')[1]]['_rowcomment'] }
}

const MatrixCellWithComment = connect(mstp)(MatrixCell)
const TableRow = Table.Row
const TableCell = Table.Cell

const cla = { textAlign: 'left' }

class _MatrixVerticalRow extends React.PureComponent {
  static defaultProps = {
    renderAs: 'select',
  }

  render() {
    const withToggleStyle = this.props.visible ? {} : { display: 'none' }
    const textStyle = { opacity: this.props.disabled ? '0.45' : '1' }
    let columns = []
    columns.push(
      <TableCell key={'vrow-0'} style={cla}>
        <span style={textStyle}>
          <HTMLText value={this.props.qtext} />
        </span>
      </TableCell>
    )
    this.props.cells.forEach(cellObject => {
      let cell = cellObject.cell
      let qName = cell.jsonref.split('.')[1]

      const itemKey = qName.split('_row_')[1]
      const valueKey = cell.key
      const cellKey = `cell-${itemKey}-${valueKey}`

      const cbProps = {
        itemKey: cell.key,
        label: cell.value,
        name: cell.key,
        selectOptions: cell.values,
        renderAs: this.props.renderAs,
        forceNativeSelect: true,
        jsonref: cell.jsonref,
        disabled: this.props.disabled,
        parentDisabled: this.props.parentDisabled,
        questionName: qName,
        currentPageName: this.props.currentPageName,
        className: `matrix-cell ${cellKey}`,
        labelClassName: 'hidden-label',
        hasComment: cell.type === 'comment' || cell.type === 'optionalcomment',
      }
      let childQuestionJsonrefArr = cell.jsonref.split('.')
      childQuestionJsonrefArr.pop()
      let childQuestionJsonref = childQuestionJsonrefArr.join('.')
      let Cell = cellObject.hasComment ? MatrixCellWithComment : MatrixCell
      columns.push(
        <Cell
          key={`item_${cell.jsonref}`}
          jsonref={childQuestionJsonref}
          parentDisabled={!this.props.active}
          questionName={qName}
          currentPageName={this.props.currentPageName}
          component={SelectField}
          childProps={cbProps}
        />
      )
    })

    return <TableRow style={withToggleStyle}>{columns}</TableRow>
  }
}
_MatrixVerticalRow.displayName = '_MatrixVerticalRow'

export default withToggle(_MatrixVerticalRow)
